import React from "react";
import Navigation from "../components/Navigation";
import { useTranslation } from "react-i18next";
import Logo from "../assets/images/logo.png";
const RegisterDelete = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Navigation title={t("REGISTER")} appBarColor="orange" />
      <div className="fixed-layout flex flex-col  ">
        <div className="white-card my-2 flex-1 flex justify-center items-center">
          <div className=" mx-auto text-center font-light text-lg">
            <img src={Logo} alt="forgot" className="w-[50%] mx-auto mb-5" />

            <p className="mb-0 text-lg font-bold">Contact us on </p>

            <p className="py-1 text-lg">
              <a href="tel:7905209748" className=" text-secondary font-light">
                7905209748
              </a>
            </p>

            <p className="mb-0 text-base text-center text-gray-500">
              For registration or <br /> delete your account.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterDelete;
